export default "__VITE_ASSET__CHjjnqGc__"